import React from 'react';
import './pinnedRepo.css';

const PinnedRepo = ({ name, description, primaryLanguage }) => {
  return (
    <li className="pinned-repo">
      <div className="item-container">
        <div className="item-outer">
          <div className="item-header">
            <svg
              className="pinned-svg"
              viewBox="0 0 16 16"
              version="1.1"
              width="16"
              height="16"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M2 2.5A2.5 2.5 0 014.5 0h8.75a.75.75 0 01.75.75v12.5a.75.75 0 01-.75.75h-2.5a.75.75 0 110-1.5h1.75v-2h-8a1 1 0 00-.714 1.7.75.75 0 01-1.072 1.05A2.495 2.495 0 012 11.5v-9zm10.5-1V9h-8c-.356 0-.694.074-1 .208V2.5a1 1 0 011-1h8zM5 12.25v3.25a.25.25 0 00.4.2l1.45-1.087a.25.25 0 01.3 0L8.6 15.7a.25.25 0 00.4-.2v-3.25a.25.25 0 00-.25-.25h-3.5a.25.25 0 00-.25.25z"
              ></path>
            </svg>

            <div className="repo-name">
              <span className="repo" title="saintly-hng">
                {name}
              </span>
            </div>

            <span className="drag" title="Drag to reorder">
              <svg
                className="drag-svg"
                viewBox="0 0 16 16"
                version="1.1"
                width="16"
                height="16"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M10 13a1 1 0 100-2 1 1 0 000 2zm-4 0a1 1 0 100-2 1 1 0 000 2zm1-5a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2zm1-5a1 1 0 11-2 0 1 1 0 012 0zM6 5a1 1 0 100-2 1 1 0 000 2z"
                ></path>
              </svg>
            </span>
          </div>

          <p className="repo-desc">
              {description}
          </p>

          <p className="language-container">
            <span className="language">
                <span className={`language-color ${primaryLanguage === 'JavaScript' ? 'javascript': primaryLanguage === 'CSS' ? 'css' : primaryLanguage === 'HTML' ? 'html' : 'typescript'}`} ></span>
  <span className="language-name">{primaryLanguage}</span>
            </span>
          </p>
        </div>
      </div>
    </li>
  );
};


export default PinnedRepo;
